// Shared with the dashboard's preferred-site seeding, which reads this grid's
// persisted site filter — keep the id in one place so a rename cannot silently
// decouple the two.
export const PM_CALENDAR_GRID_ID = 'pmcalendar';
